import { useEffect } from 'react'
import { useMainContext } from '../../modules/Dashboard'
import { usePredictContext } from './context/PredictContextProvider'
import TickersMain from './components/StartAnalyze/Main'
import ResultMain from './components/result/ResultMain'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import AssistantsMain from './components/Assistants/Main'
import FastScansMain from './components/FastScans/Main'

const entryComponentByType = {
    'assistant': <AssistantsMain />,
    'fastscan': <FastScansMain />
}

const MainAnalyzePage = () => {
    const { step: { currentStep, setCurrentStep }, ticker, assistant, reset: resetPredictContext } = usePredictContext()
    const { setMarket } = useMainContext()
    const [searchParams, setSearchParams] = useSearchParams()
    const { pathname } = useLocation()
    const urlStep = searchParams.get("step")
    const { mode } = useParams()

    // Sync context with URL step
    useEffect(() => {
        if (urlStep && ['entry', 'tickers', 'result'].includes(urlStep)) {
            setCurrentStep(urlStep)
        } else if (!pathname.includes('dashboard')) {
            setSearchParams({ step: "entry" }) // default step
        } else {
            setCurrentStep("entry")
        }

    }, [urlStep, assistant, ticker])

    // Set market based on ticker
    useEffect(() => {
        if (ticker) {
            const [coin, pair] = ticker.split('-')
            setMarket({ coin: coin?.toLowerCase(), pair: pair?.toLowerCase() })
        }
    }, [ticker])


    useEffect(() => {
        return () => {
            resetPredictContext();
        };
    }, []);

    const renderStep = {
        entry: entryComponentByType[mode],
        tickers: <TickersMain />,
        result: <ResultMain />,
    }

    return (
        <div className='block pb-10 '>
            {renderStep[currentStep]}
        </div>
    )
}

export default MainAnalyzePage
